import React from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import moment from 'moment';

import UserFieldElement from '../../../reusable/UserFieldElement';
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";
import config from "../../../../../../server/src/config";

import * as RaceActions from "../../../../actions/race";
import {NotificationManager} from "react-notifications";
import {fullfillDate, fullfillTime} from "../../../../../../common/src/util/lib";
import {confirm} from "../../../../utils/confirmDialog";
import {alert} from "../../../../utils/alertDialog";
import UserRoles from "../../../../../../common/src/enums/UserRoles";

class RaceWatch extends React.Component {

    static propTypes = {
        race: PropTypes.object,
        setEditMode: PropTypes.func.isRequired,
        setAllowNew: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            club: props.auth.currentRole === UserRoles.CLUB_ADMIN.id ? props.auth.currentEntity : '',
            editIx: null,
        };
    }

    componentDidMount() {
        if (this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id) {
            this.props.dispatch(RaceActions.getRacePigeons(this.props.race.Nr, this.props.auth.currentEntity));
            this.props.setAllowNew(true);
        }
    }

    fields = [];
    render() {
        const checkStartWeek = dtStr => {
            const dt = moment(dtStr, config.formats.dateFormat, true);
            if (dt.isValid()) return dt.isoWeek() === this.props.race.Uge || (dt.isoWeek() === this.props.race.Uge - 1 && dt.isoWeekday() >= 7);
            return true;
        };
        const checkControlWeek = dtStr => {
            const dt = moment(dtStr, config.formats.dateFormat, true);
            if (dt.isValid()) return dt.isoWeek() === this.props.race.Uge || (dt.isoWeek() === this.props.race.Uge + 1 && dt.isoWeekday() <= 4);
            return true;
        };
        return <div className={"form-page race-watch " + (this.state.editIx !== null ? "editable" : "read-only")}>
            <div className="top-panel">
                <div className="top-content">
                    <div className="block-content">
                        <table>
                            <tbody>
                                <tr>
                                    <td><label className={this.state.editIx !== null || this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ? 'disabled' : ''} htmlFor="club">Forening</label></td>
                                    <td>
                                        <UserFieldElement dataType={UserFieldDataType.enum} placeholder={'-- Vælg --'} className="field100p" containerClassName="display-inline-block field100p" disabled={this.state.editIx !== null || this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id}
                                                          name="club" id="club" value={this.state.club} options={
                                                              this.props.admin.clubs.filter(c =>
                                                                  (this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id && c.Sektionsnr !== '99') ||
                                                                  (this.props.auth.currentRole === UserRoles.SECTION_ADMIN.id && c.Sektionsnr === this.props.auth.currentEntity) ||
                                                                  (this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id && c.Foreningsnr === this.props.auth.currentEntity)
                                                              ).sort((c1, c2) => c1.Foreningsnr < c2.Foreningsnr ? -1 : (c1.Foreningsnr > c2.Foreningsnr ? 1 : 0)).map(club => (
                                                                  {key: club.Foreningsnr, value: club.Foreningsnr + (club.Navn === null ? '' : ' - ' + club.Navn)}
                                                              )).toArray()
                                                          }
                                                          autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                          onChange={e => {
                                                              this.setState({club: e.target.value});
                                                              this.props.setAllowNew((this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id || this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id) && e.target.value !== '');
                                                              this.props.dispatch(RaceActions.getRacePigeons(this.props.race.Nr, e.target.value));
                                                          }}
                                                          ref={instance => { this.fields[0] = instance; }}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div className="bottom-panel">
                <div id="data-table" className="bottom-content">
                    <div className="block-content">
                        <table className="data-table">
                            <thead>
                                <tr>
                                    <th scope="row">Slagnr</th>
                                    <th>Slagnavn</th>
                                    <th className="center">Urnr</th>
                                    <th>Startdato</th>
                                    <th>Starttid</th>
                                    <th>Kontroldato</th>
                                    <th>Kontroltid</th>
                                    <th>Udviser</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.club === '' || typeof(this.props.racePigeons.get(this.props.race.Nr + '/' + this.state.club)) === 'undefined' ? [] : this.props.racePigeons.get(this.props.race.Nr + '/' + this.state.club).pigeonholes.sort((p1, p2) => p1.Slagnr < p2.Slagnr ? -1 : (p1.Slagnr > p2.Slagnr ? 1 : 0)).concat(this.state.editIx === 'new/new' ? [['new', {Slagnr: 'new', watches: [{Urnr: 'new'}]}]] : []).toArray().map((pigeonhole, pix, prows) => {
                                    return (pigeonhole.Slagnr === 'new' ? pigeonhole.watches : pigeonhole.watches.sort((w1, w2) => w1.Urnr < w2.Urnr ? -1 : (w1.Urnr > w2.Urnr ? 1 : 0)).toArray()).map((watch, wix, wrows) => <tr key={pigeonhole.Slagnr + '/' + watch.Urnr} id={'row-' + pigeonhole.Slagnr + '-' + watch.Urnr}>
                                        <th scope="row">{
                                            this.state.editIx === pigeonhole.Slagnr + '/' + watch.Urnr ? <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field75" containerClassName="display-inline-block"
                                                           name="Slagnr" id="Slagnr" maxLength="3" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{3}"}]} value={this.state.Slagnr}
                                                           autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                           onChange={this.onStandardFieldChange}
                                                           onBlur={(e) => {
                                                               this.fields[1].setState({focused: false, visited: true});
                                                               const value = this.state.Slagnr.padStart(3, '0');
                                                               const pigeonhole = this.props.racePigeons.get(this.props.race.Nr + '/' + this.state.club).pigeonholes.get(value);
                                                               this.setState({
                                                                   Slagnr: value,
                                                                   Slagnavn: pigeonhole ? pigeonhole.Slagnavn : null,
                                                               });
                                                           }}
                                                           ref={instance => { this.fields[1] = instance; }}
                                            /> : pigeonhole.Slagnr
                                        }</th>
                                        <td>{
                                            this.state.editIx === pigeonhole.Slagnr + '/' + watch.Urnr ? this.state.Slagnavn : pigeonhole.Slagnavn
                                        }</td>
                                        <td className="center">{
                                            this.state.editIx === pigeonhole.Slagnr + '/' + watch.Urnr ? <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                                           name="Urnr" id="Urnr" maxLength="1" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[1-3]"}]} value={this.state.Urnr}
                                                           autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                           onChange={this.onStandardFieldChange}
                                                           ref={instance => { this.fields[2] = instance; }}
                                            /> : watch.Urnr
                                        }</td>
                                        <td>{
                                            this.state.editIx === pigeonhole.Slagnr + '/' + watch.Urnr ?
                                                <UserFieldElement dataType={UserFieldDataType.date} placeholder="" className="field125" containerClassName="display-inline-block"
                                                                  name="Startdato" id="Startdato" value={this.state.Startdato}
                                                                  autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                                  isError={!checkStartWeek(this.state.Startdato)} errorMessageOverride={!checkStartWeek(this.state.Startdato) ? 'Dato ligger i forkert uge.' : ''}
                                                                  onChange={this.onStandardFieldChange}
                                                                  onBlur={(e) => {
                                                                      this.fields[3].setState({focused: false, visited: true});
                                                                      const value = fullfillDate(this.state.Startdato);
                                                                      if (value !== 'error') this.setState({Startdato: value});
                                                                  }}
                                                                  ref={instance => {this.fields[3] = instance;}}
                                                /> : moment(watch.Startdato).format(config.formats.dateFormat)
                                        }</td>
                                        <td>{
                                            this.state.editIx === pigeonhole.Slagnr + '/' + watch.Urnr ?
                                                <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field100" containerClassName="display-inline-block"
                                                                  name="Starttid" id="Starttid" maxLength="8" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY, value: "([0-1][0-9]|20|21|22|23)\:[0-5][0-9]\:[0-5][0-9]"}]} value={this.state.Starttid}
                                                                  autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                                  onChange={this.onStandardFieldChange}
                                                                  onBlur={(e) => {
                                                                      this.fields[4].setState({focused: false, visited: true});
                                                                      const value = fullfillTime(this.state.Starttid, true);
                                                                      if (value !== 'error') this.setState({Starttid: value});
                                                                  }}
                                                                  ref={instance => {this.fields[4] = instance;}}
                                                /> : watch.Starttid
                                        }</td>
                                        <td>{
                                            this.state.editIx === pigeonhole.Slagnr + '/' + watch.Urnr ?
                                                <UserFieldElement dataType={UserFieldDataType.date} placeholder="" className="field125" containerClassName="display-inline-block"
                                                                  name="Kontroldato" id="Kontroldato" value={this.state.Kontroldato}
                                                                  autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                                  isError={!checkControlWeek(this.state.Kontroldato)} errorMessageOverride={!checkControlWeek(this.state.Kontroldato) ? 'Dato ligger i forkert uge.' : ''}
                                                                  onChange={this.onStandardFieldChange}
                                                                  onBlur={(e) => {
                                                                      this.fields[5].setState({focused: false, visited: true});
                                                                      const value = fullfillDate(this.state.Kontroldato);
                                                                      if (value !== 'error') this.setState({Kontroldato: value});
                                                                  }}
                                                                  ref={instance => {this.fields[5] = instance;}}
                                                /> : moment(watch.Kontroldato).format(config.formats.dateFormat)
                                        }</td>
                                        <td>{
                                            this.state.editIx === pigeonhole.Slagnr + '/' + watch.Urnr ?
                                                <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field100" containerClassName="display-inline-block"
                                                                  name="Kontroltid" id="Kontroltid" maxLength="8" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY, value: "([0-1][0-9]|20|21|22|23)\:[0-5][0-9]\:[0-5][0-9]"}]} value={this.state.Kontroltid}
                                                                  autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                                  onChange={this.onStandardFieldChange}
                                                                  onBlur={(e) => {
                                                                      this.fields[6].setState({focused: false, visited: true});
                                                                      const value = fullfillTime(this.state.Kontroltid, true);
                                                                      if (value !== 'error') this.setState({Kontroltid: value});
                                                                  }}
                                                                  ref={instance => {this.fields[6] = instance;}}
                                                /> : watch.Kontroltid
                                        }</td>
                                        <td>{
                                            this.state.editIx === pigeonhole.Slagnr + '/' + watch.Urnr ?
                                                <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field100" containerClassName="display-inline-block"
                                                                  name="Udvisen" id="Udvisen" maxLength="8" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY, value: "([0-1][0-9]|20|21|22|23)\:[0-5][0-9]\:[0-5][0-9]"}]} value={this.state.Udvisen}
                                                                  autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                                  onChange={this.onStandardFieldChange}
                                                                  onBlur={(e) => {
                                                                      this.fields[7].setState({focused: false, visited: true});
                                                                      const value = fullfillTime(this.state.Udvisen, true);
                                                                      if (value !== 'error') this.setState({Udvisen: value});
                                                                  }}
                                                                  ref={instance => {this.fields[7] = instance;}}
                                                /> : watch.Udvisen
                                        }</td>
                                        <td>{
                                            this.state.editIx === pigeonhole.Slagnr + '/' + watch.Urnr ? [
                                                <i key={0} className="fa fa-save clickable" title="Gem uroplysninger" onClick={this.save}/>,
                                                <i key={1} className="fa fa-undo clickable" title="Annuller" onClick={this.cancelEdit}/>
                                            ] : [
                                                <i key={0} className={"fa fa-pencil " + (this.state.editIx === null && (this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id || this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id) ? 'clickable' : 'disabled')} title="Rediger række" onClick={() => {
                                                    if (this.state.editIx === null && (this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id || this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id)) {
                                                        this.setState({
                                                            oldSlagnr: pigeonhole.Slagnr,
                                                            oldUrnr: watch.Urnr,
                                                            Slagnr: pigeonhole.Slagnr,
                                                            Slagnavn: pigeonhole.Slagnavn,
                                                            Urnr: String(watch.Urnr),
                                                            Startdato: watch.Startdato === null ? '' : moment(watch.Startdato).format(config.formats.dateFormat),
                                                            Starttid: watch.Starttid === null ? '' : watch.Starttid,
                                                            Kontroldato: watch.Kontroldato === null ? '' : moment(watch.Kontroldato).format(config.formats.dateFormat),
                                                            Kontroltid: watch.Kontroltid === null ? '' : watch.Kontroltid,
                                                            Udvisen: watch.Udvisen === null ? '' : watch.Udvisen,
                                                            editIx: pigeonhole.Slagnr + '/' + watch.Urnr,
                                                        });
                                                        this.props.setEditMode(true);
                                                    }
                                                }}/>,
                                                <i key={1}
                                                   className={"fa fa-trash " + (this.state.editIx === null && (this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id || this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id) ? 'clickable' : 'disabled')} title="Slet ur" onClick={() => {
                                                    if (this.state.editIx === null && (this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id || this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id)) confirm("Slet", <span>Ønsker du at slette ur <b>{watch.Urnr}</b> for slag <b>{pigeonhole.Slagnr + (pigeonhole.Slagnavn === null ? '' : ' ' + pigeonhole.Slagnavn)}</b>?</span>, () => {
                                                        this.props.dispatch(RaceActions.deleteWatch(this.props.race.Nr, this.props.race.Uge, this.state.club, pigeonhole.Slagnr, watch.Urnr, () => {
                                                            NotificationManager.success("Ur " + watch.Urnr + " er slettet for slag " + pigeonhole.Slagnr + (pigeonhole.Slagnavn === null ? '' : ' ' + pigeonhole.Slagnavn) + ".", "Sletning", 4000);
                                                        }));
                                                    });
                                                }}/>
                                            ]
                                        }</td>
                                    </tr>)
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    }

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field, ix) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    createNew = () => {
        this.setState({
            Slagnr: '',
            Slagnavn: '',
            Urnr: '',
            Startdato: '',
            Starttid: '',
            Kontroldato: '',
            Kontroltid: '',
            Udvisen: '',
            editIx: 'new/new'
        });
        this.props.setEditMode(true);
        setTimeout(function () {
            const content = document.getElementById("data-table");
            content.scrollTop = content.scrollHeight;
        });
    };

    cancelEdit = () => {
        this.setState({editIx: null});
        this.props.setEditMode(false);
    };

    save = () => {
        const doSave = () => {
            const entity = {
                Slagnr: this.state.Slagnr === '' ? null : this.state.Slagnr,
                Urnr: this.state.Urnr === '' ? null : Number(this.state.Urnr),
                Startdato: this.state.Startdato === '' ? null : moment(this.state.Startdato, config.formats.dateFormat).format('YYYY-MM-DD'),
                Starttid: this.state.Starttid === '' ? null : this.state.Starttid,
                Kontroldato: this.state.Kontroldato === '' ? null : moment(this.state.Kontroldato, config.formats.dateFormat).format('YYYY-MM-DD'),
                Kontroltid: this.state.Kontroltid === '' ? null : this.state.Kontroltid,
                Udvisen: this.state.Udvisen === '' ? null : this.state.Udvisen,
            };
            if (this.state.editIx === 'new/new') {
                entity.Ugenr = this.props.race.Uge;
                entity.Foreningsnr = this.state.club;
                this.props.dispatch(RaceActions.createWatch(this.props.race.Nr, this.state.club, entity.Slagnr, entity, () => {
                    NotificationManager.success("Ur " + this.state.Urnr + " er oprettet for slag " + entity.Slagnr + ".", "Oprettelse", 4000);
                    this.setState({editIx: null});
                    this.props.setEditMode(false);
                    setTimeout(function () {
                        const currentRow = document.getElementById("row-" + this.state.Slagnr + "-" + this.state.Urnr);
                        currentRow.scrollIntoView(false);
                    }.bind(this));
                }));
            } else this.props.dispatch(RaceActions.updateWatch(this.props.race.Nr, this.props.race.Uge, this.state.club, this.state.oldSlagnr, this.state.oldUrnr, entity, () => {
                NotificationManager.success("Ur " + this.state.Urnr + " for slag " + this.state.Slagnr + " er opdateret.", "Opdatering", 4000);
                this.setState({editIx: null});
                this.props.setEditMode(false);
                setTimeout(function () {
                    const currentRow = document.getElementById("row-" + this.state.Slagnr + "-" + this.state.Urnr);
                    currentRow.scrollIntoView(false);
                }.bind(this));
            }));
        };

        if (this.allInputValid()) {
            const sDt = moment(this.state.Startdato, config.formats.dateFormat).toDate();
            const cDt = moment(this.state.Kontroldato, config.formats.dateFormat).toDate();
            if (cDt.getTime() < sDt.getTime() || (cDt.getTime() === sDt.getTime() && this.state.Kontroltid <= this.state.Starttid)) {
                alert('Fejl', <span>Kontroltid ligger før starttid.</span>, () => {});
                return ;
            }
            const startSecond = 3600 * Number(this.state.Starttid.substr(0, 2)) + 60 * Number(this.state.Starttid.substr(3, 2)) + Number(this.state.Starttid.substr(6, 2));
            const controlSecond = (cDt.getTime() - sDt.getTime()) / 1000 + 3600 * Number(this.state.Kontroltid.substr(0, 2)) + 60 * Number(this.state.Kontroltid.substr(3, 2)) + Number(this.state.Kontroltid.substr(6, 2)) - startSecond;
            const measuredSecond = (cDt.getTime() - sDt.getTime()) / 1000 + 3600 * Number(this.state.Udvisen.substr(0, 2)) + 60 * Number(this.state.Udvisen.substr(3, 2)) + Number(this.state.Udvisen.substr(6, 2)) - startSecond;
            const error = (controlSecond - measuredSecond) / controlSecond;
            if (error > 1 / 7200) {
                confirm("Fejlgang", <span>Fejlgangen overstiger 1 / 7200. Kan uroplysningerne alligevel accepteres?</span>, () => {
                    doSave();
                }, null, {okText: 'Ja', cancelText: 'Nej'});
            } else doSave();


        } else {
            this.fields.forEach((field) => {
                field.setState({visited: true});
            });
        }
    }
}

const mapStateToProps = (state) => ({
    auth: {
        currentRole: state.auth.currentRole,
        currentEntity: state.auth.currentEntity,
    },
    admin: {
        clubs: state.admin.clubs,
    },
    racePigeons: state.race.racePigeons,
});

export default connect(mapStateToProps, null, null, {withRef: true})(RaceWatch);



// WEBPACK FOOTER //
// ./src/client/src/components/pages/race/subPages/RaceWatch.js